@if (hasPublishedItems()) {
<rds-divider class="divider"></rds-divider>
<div class="best-practices">
  <h1 class="ui-heading-1-bold best-practices-title">
    {{ knowledgeSection() }}
  </h1>

  <div class="best-practices-content">
    @for(b of bestPractices(); track $index) {
      @if(b.published === true) {
        <div class="best-practices-item">
          <h3 class="ui-heading-3">{{ b.title }}</h3>
          <div [innerHTML]="b?.description | safeHtml"></div>
        </div>
      }
    }
  </div>
</div>
}
